/*
    模块组件
    ChenYN

    说明
    主页底部切换栏

    版本
    1.0

    传参
        name Sting : 当前页面的name(同路由)
    依赖
    /style/2019/h5/css/common.css
    vue.js

    案例
    <demo></demo>
*/
<template>
    <div class="recommend_wrap">
        <div class="scroll_wrapper">
            <div class="refresh_wrap">
                <span v-if="isRefreshing"><Loading color="#333" size="24px">加载中...</Loading></span>
                <span v-else>{{refreshTxt}}</span>
            </div>

            <!-- 轮播图 -->
            <div class="banner_wrapper" v-if="bannerList && bannerList.length > 0">
                <Swipe class="my_swipe" loop :show-indicators="false" autoplay="3000" @change="swipeChange" :stop-propagation="false">
                    <SwipeItem v-for="(v,i) in bannerList" :key="i" @click.stop="util.goLink(v.link)">
                        <img :src="v.url">
                        <div class="slide_txt">
                            <p class="van-ellipsis">{{v.title}}</p>
                            <p class="van-ellipsis">{{v.subtitle}}</p>
                        </div>
                    </SwipeItem>
                </Swipe>
                <div class="dots_wrapper">
                    <span class="dot" v-for="(v,i) in bannerList" :key="i" :class="{'active': currentPageIndex === i}"></span>
                </div>
            </div>

            <!-- 常驻活动 -->
            <div class="permanent_wrap" v-if="activities && activities.length > 0">
                <div class="type_title">
                    <span>精彩活动</span>
                    <!-- <img src="@/assets/images/find/icon_input.png" alt=""> -->
                </div>
                <div class="permanent_list">
                    <Swipe ref="activitiesSwipe" :width="(windowWidth - 46) / 2" :autoplay="3000" indicator-color="white" :loop="false" :stop-propagation="false" :show-indicators="false">
                        <SwipeItem v-for="(v, i) in activities" :key="i">
                            <div class="permanent_item"  @click.stop="util.goLink(v.link)">
                                <img :src="v.url" :alt="v.title">
                            </div>
                        </SwipeItem>
                    </Swipe>
                </div>
            </div>

            <!-- 热门游戏 -->
            <div class="permanent_wrap" v-if="hot_games && hot_games.length > 0">
                <div class="type_title" @click="goState({name: 'gamelist'})">
                    <span>热门游戏</span>
                    <img src="@/assets/images/find/icon_input.png" alt="">
                </div>

                <div class="game_list">
                    <div class="game_item" v-for="v in hot_games" :key="v.game_id"  @click="goState({name: 'gamedetail', params: {gameid: v.game_id}})">
                        <game-grid :game="v" type="recom"></game-grid>
                    </div>
                    <div class="game_item" v-for="v in (hot_games.length % 4 == 0 ? 0 : 4 - hot_games.length % 4 )" :key="v"></div>
                </div>
            </div>

            <!-- 热门话题 -->
            <div class="forum_wrapper">

                <div class="title">热门话题</div>

                <div class="forum_item" v-for="v in forumList" :key="v.tid" >
                    <forum :deleteForum="deleteForum" :isLikesFun="goLike" :forumData="v" :tagTop="v.forum.name"></forum>
                </div>

            </div>

            <empty-status v-if="forumList && forumList.length <= 0"></empty-status>

            <div class="refresh_bottom">{{refreshUptxt}}</div>
        </div>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, onActivated, computed,  onBeforeMount } from 'vue';
import router from "@/router"
import Util from '@/assets/js/lib/util';
import GameGrid from '@/components/Seven_GameGrid/GameGrid.vue';
import Forum from '@/components/Seven_Forum/Forum.vue';
import BScroll from '@better-scroll/core'
import Pulldown from '@better-scroll/pull-down'
import Pullup from '@better-scroll/pull-up'
import ObserveImage from '@better-scroll/observe-image'
BScroll.use(Pullup)
BScroll.use(Pulldown)
BScroll.use(ObserveImage)
import { Swipe, SwipeItem, Loading,  } from "vant"
import EmptyStatus from "@/components/Seven_EmptyStatus/EmptyStatus.vue";

export default defineComponent({
    name: 'Recommend',
    components: { GameGrid, Swipe, SwipeItem, GameGrid, Loading, Forum, EmptyStatus, },
    props: {
        name: {
            type: String,
            default: 'index'
        }
    },
    setup(props) {
        const state = reactive({
            util: new Util(),
            bs: '',
            refreshUptxt: '加载更多',
            refreshTxt: '下拉刷新', //下拉刷新提示文字
            isRefreshing: false, //是否正在刷新中
            page: 1,
            total: 1,
            limit: 4,
            currentPageIndex: 0,
            windowWidth: window.innerWidth, //当前页面宽度
            activitiesSwipe: null,
        });
        const data = reactive({
            bannerList: [], // 轮播图数据
            activities: [], // 常驻活动
            hot_games: [], // 热门游戏
            forumList: [], //热门主题列表
        });
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
            swipeChange: (e) => state.currentPageIndex = e,
            deleteForum: (params) => { //删除主题
                Dialog.confirm({
                    title: '删除主题',
                    message: '是否确定删除此主题',
                })
                .then(() => {
                    reqDelete(params);
                })
                .catch(() => {});
            },
            goLike: async (o) => {//点赞事件
                const res = await state.util.getJson('/thread/like', 'POST', o, true);
                if(res.code == 0){
                    await reqShamPraise(o);

                    setTimeout(() => {
                        state.bs.refresh();
                    }, 300);
                }else {
                    window.Components.toast(res.msg)
                }
            },
        }; //需要对外暴露的方法

        const reqShamPraise = async (params) => { //虚假更新点赞
            data.forumList.forEach((item,index) => {
                if(item.tid == params.tid){
                    data.forumList[index].user_like = params.status
                    if(data.forumList[index].user_like == 1){
                        data.forumList[index].likes += 1
                    }else{
                        data.forumList[index].likes -= 1
                    }
                }
            });
        };

        onMounted(async () => {
            await reqGameData();
            await reqForumList();

            initScroll();
        });

        onActivated(async () => {
            await changeList();

            if(state.bs == ''){
                initScroll();
            }else {
                state.bs.refresh();
            }
        })


        const initScroll = () => { //初始化上下滚动
            state.bs = new BScroll('.recommend_wrap',{
                scrollY: true,
                click: false,
                preventDefault: false,
                probeType: 2,
                bounceTime: 400,
                swipeBounceTime: 400,
                outOfBoundaryDampingFactor: 0.6,
                pullDownRefresh: {
                    threshold: 50,
                    stop: 40 //这样就会回到顶部了
                },
                pullUpLoad: { //上拉加载
                    threshold: -40
                },
                deceleration: 0.009,
                observeImage: true
            })

            state.bs.on('scroll',  (position) => {
                if(position.y < 38){
                    state.refreshTxt = '下拉刷新';
                    state.isRefreshing = false;
                    state.bs.finishPullDown();
                }else {
                    state.refreshTxt = '释放刷新'
                }
            });

            state.bs.on('pullingDown', async () => {

                state.isRefreshing = true;
                state.page = 1;
                state.total = 1;

                await reqGameData();

                setTimeout(() => {
                    window.Components.toast('刷新成功');
                    state.bs.finishPullDown();
                    state.bs.finishPullUp();
                }, 300);
            });

            state.bs.on('pullingUp', async () => {

                if(state.page > state.total){
                    state.refreshUptxt = '暂无更多数据';
                    return
                }
                state.refreshUptxt= '加载更多';

                await reqForumList(true);

                setTimeout(() => {
                    state.bs.finishPullUp();
                    state.bs.refresh();
                }, 300);
            });

            setTimeout(() => {
                state.bs.refresh();
            }, 100);
        };

        const reqGameData = async () => { //页面数据
            const res = await state.util.getJson('/index', 'GET', {}, true);
            if(res.code == 0){
                data.bannerList = res.data.carousel;
                data.activities = res.data.activities;
                data.hot_games = res.data.hot_games;

                setTimeout(() => {
                    state.activitiesSwipe&&state.activitiesSwipe.resize();
                }, 1000);
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqForumList = async (flag = false) => { //请求帖子列表
            const params = {
                page: state.page,
                per_page: state.limit
            }

            const res = await state.util.getJson('/index/thread', 'GET', params, true);
            if(res.code == 0){
                if(flag){ //加载更多
                    data.forumList.push(...res.data.thread);
                }else{ //刷新
                    data.forumList = res.data.thread;
                }

                state.page += 1;
                if(res.data.total > 1){
                    state.total = res.data.total;
                };
            }else {
                window.Components.toast(res.msg)
            }
        };

        const changeList = async () => { //局部刷新数据
            let params = {
                page: 1,
                per_page: state.limit * (state.page - 1 < 1 ? 1 : state.page - 1),
            }

            const res = await state.util.getJson('/index/thread', 'GET', params, true);
            if(res.code == 0){
                data.forumList = res.data.thread;
                state.total = res.data.total;
            }else {
                window.Components.toast(res.msg)
            }
        };

        const reqDelete = async (params) => { //删除主题
            const res = await state.util.getJson('/thread/delete', 'POST', params, true);

            if(res.code == 0){
                window.Components.toast('删除成功');
                await changeList();
            }else {
                window.Components.toast(res.msg)
            }
        };

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./Recommend.less";
</style>